import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  deleteCycleImage,
  uploadCycleImage,
  getReciptImage
} from "../../../apis/CycleImageApi";
import { RECEIPT_TYPE } from "../../../utils/constants";
import "./cycleRecipt.scss";

function CycleReceipt(props) {
  const [inputList, setInputList] = useState(() => {
    let initialList = [];
    if (props.editorValues?.imageList && props.editorValues.imageList.length > 0) {
      initialList = props.editorValues.imageList.map(img => ({
        id: img.id,
        receipt: RECEIPT_TYPE.find(item => item.name === img.receipt) || { name: img.receipt },
        file: img.image || "existing",
        isExisting: true
      }));
    }
    if (initialList.length === 0) {
      initialList.push({ receipt: {}, file: null });
    }
    return initialList;
  });

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const toast = useRef(null);
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const item = inputList[index];
    if (item.id) {
      deleteCycleImage(item.id).then((res) => {
        if (res.status === 200) {
          let newInputList = inputList.filter((_, i) => index !== i);
          if (newInputList.length === 0) {
            newInputList.push({ receipt: {}, file: null });
          }
          setInputList(newInputList);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Image Deleted Successfully",
            life: 3000,
          });
        }
      });
    } else {
      let newInputList = inputList.filter((_, i) => index !== i);
      if (newInputList.length === 0) {
        newInputList.push({ receipt: {}, file: null });
      }
      setInputList(newInputList);
    }
  };

  const handleAddClick = () => {
    setInputList([...inputList, { receipt: {}, file: null }]);
  };

  const handlePreview = (item) => {
    if (item.file && item.file !== "existing") {
      setPreviewImage(item.file);
      setPreviewVisible(true);
    } else if (item.id) {
      getReciptImage(props.cycleId, item.receipt.name).then(res => {
        if (res.status === 200 && res.data.image) {
          setPreviewImage(res.data.image);
          setPreviewVisible(true);
        }
      });
    }
  };

  const tobase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const onBasicUpload = async (event, x, i) => {
    const file = event.files[0];
    var base64data = await tobase64(file);

    let newData = {
      receipt: x.receipt.name,
      image: base64data,
      cycleId: {
        id: props.cycleId,
      },
    };

    uploadCycleImage(newData).then((res) => {
      if (res.status === 200) {
        let savedData = {
          id: res.data.id,
          receipt: RECEIPT_TYPE.find((item) => item.name === res.data.receipt) || { name: res.data.receipt },
          file: res.data.image,
          isExisting: true
        };
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Image Uploaded Successfully",
          life: 3000,
        });
        
        const newList = [...inputList];
        newList[i] = savedData;
        setInputList(newList);
      }
    });
  };

  return (
    <div className="App">
      <Toast ref={toast} position="top-center" />
      
      <Dialog visible={previewVisible} onHide={() => setPreviewVisible(false)} header="Image Preview" style={{ width: '50vw' }}>
        {previewImage && <img src={previewImage} alt="Preview" style={{ width: '100%', height: 'auto' }} />}
      </Dialog>

      {inputList.map((x, i) => {
        return (
          <React.Fragment key={i}>
            <div className="box">
              <div className="flex align-items-center mb-3">
                <label
                  htmlFor="receipt"
                  className="w-4 mb-0"
                >
                  Image Type
                </label>
                <div
                  className="w-8 flex align-items-center gap-2"
                >
                  <Controller
                    name={`receipt_${i}`}
                    control={control}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                        id={`receipt_${i}`}
                        style={{ width: "210px" }}
                        options={RECEIPT_TYPE}
                        optionLabel={(option) => option.name}
                        value={x.receipt}
                        onChange={(e) => {
                           handleInputChange({ target: { name: 'receipt', value: e.value } }, i);
                        }}
                        placeholder="Select Image Type"
                        disabled={x.isExisting}
                      />
                    )}
                  />
                  {getFormErrorMessage(`receipt_${i}`)}

                  {!x.isExisting && (
                    <FileUpload
                      mode="basic"
                      uploadHandler={(file) => {
                        onBasicUpload(file, x, i);
                      }}
                      name="file"
                      value={x.file}
                      chooseLabel="Browse"
                      accept="image/*"
                      maxFileSize={10000000}
                      customUpload
                      auto
                      disabled={!x.receipt?.name}
                    />
                  )}
                  {x.isExisting && (
                    <Button 
                      type="button" 
                      label="Preview" 
                      icon="pi pi-eye" 
                      className="p-button-outlined p-button-info" 
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreview(x);
                      }} 
                    />
                  )}

                  {(inputList.length > 1 || x.isExisting) && (
                    <Button
                      type="button"
                      label="Remove"
                      icon="pi pi-trash"
                      className="p-button-danger"
                      onClick={(e) => {
                        e.preventDefault();
                        handleRemoveClick(i);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="flex">
              <div>
                {inputList.length - 1 === i && (
                  <Button
                    type="button"
                    className="mt-2 mb-2"
                    label="Add New Image"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddClick();
                    }}
                  />
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default CycleReceipt;
